import { flatten } from './objectUtils';

import {
  deObj,
  enObj,
  esObj,
  esMXObj,
  frCAObj,
  frObj,
  itObj,
  jaObj,
  ptObj
} from './locales';

const de = flatten(deObj['de-DE']);
const en = flatten(enObj['en']);
const es = flatten(esObj['es-ES']);
const esMX = flatten(esMXObj['es-MX']);
const frCA = flatten(frCAObj['fr-CA']);
const fr = flatten(frObj['fr-FR']);
const it = flatten(itObj['it-IT']);
const ja = flatten(jaObj['ja-JP']);
const pt = flatten(ptObj['pt-BR']);

const messages = {
  de: de,
  'de-DE': de,
  en,
  'en-US': en,
  es,
  'es-ES': es,
  'es-MX': esMX,
  fr,
  'fr-FR': fr,
  'fr-CA': frCA,
  it,
  'it-IT': it,
  ja,
  'ja-JP': ja,
  pt,
  'pt-BR': pt
};

export default messages;
